import * as actionTypes from "./actionTypes"
import * as types from "./types"

// Toggle workflow

export const enableWorkflow = (): types.EnableWorkflow => ({
    type: actionTypes.ENABLE_WORKFLOW,
})

export const disableWorkflow = (): types.DisableWorkflow => ({
    type: actionTypes.DISABLE_WORKFLOW,
})

export const resetWorkflow = (): types.ResetWorkflow => ({
    type: actionTypes.RESET_WORKFLOW,
})

export const triggerMainWorkflow = (): types.TriggerMainWorkflow => ({
    type: actionTypes.TRIGGER_MAIN_WORKFLOW,
})

// Workflow steps

export const nextStep = (): types.NextStep => ({
    type: actionTypes.NEXT_STEP,
})

export const prevStep = (): types.PrevStep => ({
    type: actionTypes.PREV_STEP,
})

export const goToStep = (step: number): types.GoToStep => ({
    type: actionTypes.GOTO_STEP,
    step,
})

// Toggle data

export const toggleDataSet = (dataSet: any): types.ToggleDataSet => ({
    type: actionTypes.TOGGLE_SELECTED_DATA_SET,
    dataSet,
})

export const toggleDataTarget = (dataTarget: any): types.ToggleDataTarget => ({
    type: actionTypes.TOGGLE_SELECTED_DATA_TARGET,
    dataTarget,
})

